export const EDIT_PROFILE_LOADING = "EDIT_PROFILE_LOADING";
export const EDIT_PROFILE_SUCCESS = "EDIT_PROFILE_SUCCESS";
export const CATCH_ERROR_EDIT_PROFILE = "CATCH_ERROR_EDIT_PROFILE";
export const CLEAR_ERROR_EDIT_PROFILE = "CLEAR_ERROR_EDIT_PROFILE";
